import React from "react";
import styled, { css } from "styled-components";


export const InnerWrapper = styled.div(({ theme }) => css`
    display: flex;
    flex-direction: column;
    background-color: ${theme.palette.main.fieldWell};
    border-radius: 12px;

    .double-repayment-title {
        padding-bottom: 35px;
    }

    .repayment-infomation {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom: 15px;
        max-width: 380px;

        p {
            padding-right: 20px;
            padding-bottom: 5px;
        }

        @media only screen and (min-width: ${theme.breakpoints.S}) {
            flex-direction: row;

            p {
                padding-right: 120px;
                padding-bottom: 0;
            }
        }
    }

    .double-repayment-submit {
        display: flex;
        justify-content: flex-end;
    }

    .double-repayment-button {
        margin: 30px 0 0;
        background-color: ${theme.buttons.secondary.background};
        color: ${theme.buttons.secondary.color};
        font-size: ${theme.buttons.fontSize};
        font-weight: ${theme.buttons.fontWeight};

        @media (hover: hover) {
            &:hover {
                color: ${theme.buttons.secondary.colorHover};
                background-color: ${theme.buttons.secondary.backgroundHover};
            }
        }
    }
`);

const OuterWrapper = styled.div`
    padding: 5px 0 20px;
`;

export const Wrapper = ({children}) => (
    <OuterWrapper>
        <InnerWrapper>
            {children}
        </InnerWrapper>
    </OuterWrapper>
);